import { useTranslation, t } from '../i18n';
import React from 'react';
import { Tag } from 'antd';

/**
 * Single source of truth for DNS zone status -> {color, text} mapping.
 *
 * Previously the user side (src/user/pages/dns/DnsZones.jsx) and the admin side
 * (src/admin/pages/dns/DnsZones.jsx) each kept their own status map and had
 * drifted: the user side used pending/待激活 while the admin side used
 * inactive/未激活, and the same zone could render differently depending on which
 * side you viewed it from. Import this helper so all surfaces stay in sync and
 * every backend status has an explicit mapping.
 */
export const DNS_ZONE_STATUS_MAP = {
  active: { color: 'success', text: '活跃' },
  pending: { color: 'warning', text: '待激活' },
  inactive: { color: 'default', text: '未激活' },
  suspended: { color: 'warning', text: '已暂停' },
  terminated: { color: 'error', text: '已终止' },
  deleted: { color: 'default', text: '已删除' },
};

/**
 * Resolve the {color, text} config for a DNS zone status. Unknown statuses fall
 * back to a default-colored tag that shows the raw status string.
 * @param {string} status
 * @returns {{color: string, text: string}}
 */
export function dnsZoneStatusConfig(status) {
  return DNS_ZONE_STATUS_MAP[status] || { color: 'default', text: status || t('Unknown') };
}

/**
 * Reusable status Tag for a DNS zone.
 */
const DnsZoneStatusTag = ({ status }) => {
  const { t } = useTranslation();
  const config = dnsZoneStatusConfig(status);
  return <Tag color={config.color}>{t(config.text)}</Tag>;
};

export default DnsZoneStatusTag;
